import { useNavigate } from 'react-router-dom';
import { ArrowRight } from '../icons';
import { Button } from '../ui/button';

export function NLPCTA() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 bg-nlp-forest relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-nlp-gold/10 rounded-full blur-3xl" />
      <div className="max-w-[1216px] mx-auto relative">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="flex-1 relative hidden lg:block">
            <div className="relative max-w-sm mx-auto">
              <div className="absolute inset-0 bg-nlp-gold/20 rounded-[32px] transform -rotate-3" />
              <div className="relative bg-nlp-bg rounded-[32px] shadow-xl p-6 border border-nlp-cream-dark">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 bg-nlp-olive/15 rounded-full flex items-center justify-center">
                    <span className="text-2xl">🎯</span>
                  </div>
                  <div>
                    <p className="font-semibold text-nlp-forest">
                      Your Growth Journey
                    </p>
                    <p className="text-sm text-nlp-taupe">
                      Personalized for you
                    </p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 p-3 bg-nlp-cream/50 rounded-xl">
                    <div className="w-8 h-8 bg-nlp-forest rounded-full flex items-center justify-center text-white text-sm font-bold">
                      1
                    </div>
                    <span className="text-sm text-nlp-forest">
                      Complete Assessment
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-nlp-cream/30 rounded-xl">
                    <div className="w-8 h-8 bg-nlp-taupe rounded-full flex items-center justify-center text-white text-sm font-bold">
                      2
                    </div>
                    <span className="text-sm text-nlp-taupe">
                      Get AI Insights
                    </span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-nlp-cream/30 rounded-xl">
                    <div className="w-8 h-8 bg-nlp-taupe rounded-full flex items-center justify-center text-white text-sm font-bold">
                      3
                    </div>
                    <span className="text-sm text-nlp-taupe">
                      Connect with Coach
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2
              className="text-3xl md:text-4xl font-bold text-nlp-bg mb-4"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Take Care of Your Growth — Start Today
            </h2>
            <p className="text-lg text-nlp-cream mb-8 max-w-xl mx-auto lg:mx-0">
              Don't wait to take the first step. Your journey to self-discovery
              starts with a simple, science-backed assessment available now —
              anytime, any device.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={() => navigate('/register')}
                className="gap-2 bg-nlp-gold text-nlp-forest hover:bg-nlp-gold-light rounded-full"
              >
                Get Started Now
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/coach-registration')}
                className="border-nlp-gold/50 text-nlp-bg hover:bg-nlp-gold/10 rounded-full"
              >
                Become a Coach
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
